global.comentarioGlobal  = "";
global.cambio  = false;
global.ventanaDocumentoFalso  = false;
global.fechaInicial = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);